export const unreadCountScreenReaderOnlyText = "Zvd";
export default {unreadCountScreenReaderOnlyText};